var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "home row" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-9" }, [
      _c(
        "h1",
        {
          staticClass: "display-4",
          domProps: { textContent: _vm._s(_vm.$t("home.title")) },
        },
        [_vm._v("Welcome, Java Hipster!")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "lead",
          domProps: { textContent: _vm._s(_vm.$t("home.subtitle")) },
        },
        [_vm._v("This is your homepage")]
      ),
      _vm._v(" "),
      _c("div", [
        _vm.authenticated
          ? _c("div", { staticClass: "alert alert-success" }, [
              _vm.username
                ? _c(
                    "span",
                    {
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("home.logged.message", {
                            username: _vm.username,
                          })
                        ),
                      },
                    },
                    [
                      _vm._v(
                        'You are logged in as user "' +
                          _vm._s(_vm.username) +
                          '"'
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("p", { domProps: { textContent: _vm._s(_vm.$t("home.question")) } }, [
        _vm._v("If you have any question on JHipster:"),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.jhipster.tech/",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              domProps: { textContent: _vm._s(_vm.$t("home.link.homepage")) },
            },
            [_vm._v("JHipster homepage")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "http://stackoverflow.com/tags/jhipster/info",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              domProps: {
                textContent: _vm._s(_vm.$t("home.link.stackoverflow")),
              },
            },
            [_vm._v("JHipster on Stack Overflow")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://github.com/jhipster/generator-jhipster/issues?state=open",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              domProps: { textContent: _vm._s(_vm.$t("home.link.bugtracker")) },
            },
            [_vm._v("JHipster bug tracker")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://gitter.im/jhipster/generator-jhipster",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              domProps: { textContent: _vm._s(_vm.$t("home.link.chat")) },
            },
            [_vm._v("JHipster public chat room")]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "a",
            {
              attrs: {
                href: "https://twitter.com/jhipster",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              domProps: { textContent: _vm._s(_vm.$t("home.link.follow")) },
            },
            [_vm._v("follow @jhipster on Twitter")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("span", { domProps: { textContent: _vm._s(_vm.$t("home.like")) } }, [
          _vm._v("If you like JHipster, don't forget to give us a star on"),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://github.com/jhipster/generator-jhipster",
              target: "_blank",
              rel: "noopener noreferrer",
            },
            domProps: { textContent: _vm._s(_vm.$t("home.github")) },
          },
          [_vm._v("GitHub")]
        ),
        _vm._v("!\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-md-3" }, [
      _c("span", { staticClass: "hipster img-fluid rounded" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }